// 公共页脚
<template>
  <div class="foot">
    <div class="fcenter">
      <div class="leftBottom">
        <div class="leftTop">
          <div class="bottomImg"></div>
          <!-- <p>业务咨询：400-001-6911</p> -->
          <p>客服电话：0371-65353150</p>
          <p>地址：河南省郑州市郑东新区郑开大道89号河南建设大厦</p>
        </div>
        <div class="leftErweima">
          <!-- <div class="erweima">
            <div class="erweiImg"></div>
            <p>详情咨询</p>
          </div> -->
          <div class="erweima2">
            <div class="erweiImg2"></div>
            <p>官方公众号</p>
          </div>
        </div>
      </div>
      <div class="centerBottom">
        <a class="titleBottom">登录入口</a>
        <a href="http://www.wtzhgd.com/#/" class="last" target="_blank">伍通智慧工地信息平台</a>
        <a class="titleBottom">业务介绍</a>
        <a href="javascript:;" @click="project">工程项目质量全面提升过程咨询</a>
        <a href="javascript:;" @click="train">专项培训</a>
        <a href="javascript:;" @click="information">项目信息化建设</a>
        <a href="javascript:;" @click="law">法律服务咨询</a>
        <a href="javascript:;" @click="double">双重预防体系咨询服务</a>
        <a href="javascript:;" @click="items">项目汇报视频PPT材料服务</a>
      </div>
      <div class="rightBottom">
        <a class="titleBottom">友情链接</a>
        <a href="http://www.mohurd.gov.cn/" target="_blank">中华人民共和国住房和城乡建设部</a>
        <a href="http://www.hnjs.gov.cn/" target="_blank">河南省住房和城乡建设厅</a>
        <a href="http://www.zgjzy.org.cn/" target="_blank">中国建筑业协会</a>
        <a href="http://www.hnscia.com/web/index.html" target="_blank">河南省建筑业协会</a>
        <a href="http://www.yhtypt.com/" target="_blank">源恒通软件</a>
        <a href="http://ywtxxkj.cn" target="_blank">源伍通科技</a>
        <!-- <a href="http://www.lubansoft.com/" target="_blank">鲁班软件</a> -->
        <a href="javascript:;" class="titleBottom aboutOur" @click="about">关于我们</a>
        <a href="javascript:;" class="titleBottom" @click="lianxi">联系我们</a>
      </div>
    </div>
    <div class="bott">
      <p>
        <a href="javascript:;" @click="copyright">&copy;2021 河南建协工程咨询有限公司&nbsp;版权所有</a>&nbsp;&nbsp;&nbsp;
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          v-if="show"
          target="_blank"
        >网站备案许可号：豫ICP备20210066 19号-1</a>
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          v-if="!show"
          target="_blank"
        >网站备案许可号：豫ICP备20210066 19号-2</a>
      </p>
      <p>技术支持：源伍通科技 电话：0371-65353150</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    console.log(window.location.href);
    var com = "com";
    var cn = "cn";
    if (window.location.href.match(com)) {
      this.show = false;
    } else if (window.location.href.match(cn)) {
      this.show = true;
    }
  },
  methods: {
    project() {
      this.$router.replace("/project");
    },
    items() {
      this.$router.replace("/items");
    },
    law() {
      this.$router.replace("/law");
    },
    information() {
      this.$router.replace("/information");
    },
    train() {
      this.$router.replace("/train");
    },
    double() {
      this.$router.replace("/double");
    },
    aboutour() {
      this.$router.replace("/aboutour");
    },
    about() {
      this.$router.replace("/aboutour");
    },
    lianxi() {
      this.$router.replace("/serve");
    },
    copyright() {
      this.$router.replace("/copyright");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.foot {
  width: 100%;
  height: 590px;
  font-size: 12px;
  background-color: #f1f1f1;
  box-sizing: border-box;
  position: relative;
  .fcenter {
    width: 1160px;
    height: 590px;
    margin: 1px auto;
    display: flex;
    justify-content: space-around;
  }
  .leftBottom {
    width: 411px;
    height: 590px;
    padding-top: 1px;
    // margin-left: 361px;
    box-sizing: border-box;
    float: left;
    .leftTop {
      width: 100%;
      height: 220px;
      margin-top: 39px;
      .bottomImg {
        width: 384px;
        height: 49px;
        background: url("../assets/img/icon/headernn.png") 0px -5px no-repeat;
        background-size: cover;
      }
      p {
        width: 411px;
        height: 25px;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #333333;
      }
    }
    .leftErweima {
      width: 411px;
      height: 136px;
      display: flex;
      // margin-top: 68px;
      justify-content: space-between;
      .erweima {
        font-size: 14px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        color: #333333;
        .erweiImg {
          width: 117px;
          height: 117px;
          background: url("../assets/img/首页/wxErWeiMa.jpg") center no-repeat;
          background-size: cover;
        }
        p {
          text-align: center;
        }
      }
      .erweima2 {
        .erweiImg2 {
          width: 117px;
          height: 117px;
          background: url("../assets/img/首页/gcErWeiMa.jpg") center no-repeat;
          background-size: cover;
        }
        p {
          text-align: center;
        }
      }
    }
  }
  .centerBottom {
    width: 196px;
    // position: absolute;
    // top: 43px;
    // left: 992px;
    margin-top: 40px;
    .last {
      margin-bottom: 58px;
    }
    a {
      display: block;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      margin-bottom: 19px;
    }
    a:hover {
      color: #4279db;
    }
    .titleBottom {
      display: block;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: left;
      color: #4279db;
      margin-bottom: 22px;
    }
  }
  .rightBottom {
    width: 210px;
    // position: absolute;
    // top: 43px;
    // left: 1355px;
    margin-top: 40px;
    a {
      display: block;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      margin-bottom: 19px;
    }
    a:hover {
      color: #4279db;
    }
    .titleBottom {
      display: block;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: left;
      color: #4279db;
      margin-bottom: 22px;
    }
    .aboutOur {
      margin-bottom: 20px;
    }
  }
  .bott {
    width: 100%;
    height: 89px;
    border-top: 2px solid #4279db;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    p {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      color: #333333;
      margin-top: 10px;
      a {
        display: inline-block;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        color: #333333;
        margin-right: 50px;
      }
      a:hover {
        color: #4279db;
      }
    }
  }
}
</style>
